// extracted by mini-css-extract-plugin
export var blue = "_2z-f";
export var brand = "_2z-b";
export var darkGrey = "_2z-e";
export var disabled = "_2z-4";
export var disabledSubtle = "_2z-5";
export var error = "_2z-6";
export var green = "_2z-g";
export var grey = "_2z-d";
export var icon = "_2z-0";
export var inherit = "_2z-a";
export var lightGrey = "_2z-c";
export var orange = "_2z-i";
export var pink = "_2z-k";
export var primary = "_2z-1";
export var purple = "_2z-l";
export var red = "_2z-j";
export var secondary = "_2z-2";
export var success = "_2z-9";
export var tertiary = "_2z-3";
export var warning = "_2z-7";
export var warningSecondary = "_2z-8";
export var white = "_2z-m";
export var yellow = "_2z-h";